import http from './interceptor';
// const baseUrl = 'http://localhost:9966/super/';
// export const imgBase = "http://localhost:9966/static/";
// const baseUrl = "https://pheriwala.app/pherib/super/";
// export const imgBase = "https://pheriwala.app/pherib/static/";
// const baseUrl = 'http://localhost:9966/super/';
// export const imgBase = 'http://localhost:9966/static/';
// const baseUrl = 'https://freshfresh.in/pherib/super/';
// export const imgBase = 'https://freshfresh.in/pherib/static/';
const baseUrl = 'https://api.theminto.com/super/';
export const imgBase = 'https://api.theminto.com/static/';

// session
export default (data) => {
  return http.put(`${baseUrl}login`, data); // { phone, password }
};
export const logoutReq = (data) => {
  return http.get(`${baseUrl}logout`, { params: data }); // { id }
};
export const refreshTokenReq = (auth) => {
  return http.get(`${baseUrl}refresh`, { headers: { auth } });
};

// region
export const addregionReq = (data) => {
  return http.post(`${baseUrl}region`, data); // { name, pincode }
};
export const updregionReq = (data) => {
  return http.put(`${baseUrl}region`, data); // { id, name, pincode }
};
export const getregionReq = () => {
  return http.get(`${baseUrl}region`); // {  }
};
export const rmregionReq = (data) => {
  return http.delete(`${baseUrl}region`, { data }); // { id }
};

// admin
export const addadminReq = (data) => {
  return http.post(`${baseUrl}admin`, data); // { name, phone, password, region }
};
export const updadminReq = (data) => {
  return http.put(`${baseUrl}admin`, data); // { id, name, phone, region }
};
export const chAdPassReq = (data) => {
  return http.put(`${baseUrl}adpass`, data); // { id, password }
};
export const getadminReq = () => {
  return http.get(`${baseUrl}admin`); // {  }
};
export const rmadminReq = (data) => {
  return http.delete(`${baseUrl}admin`, { data }); // { is }
};

// user
export const adduserReq = (data) => {
  return http.post(`${baseUrl}user`, data); // { name, phone, password, region }
};
export const upduserReq = (data) => {
  return http.put(`${baseUrl}user`, data); // { id, name, phone, region }
};
export const chUsPassReq = (data) => {
  return http.put(`${baseUrl}uspass`, data); // { id, password }
};
export const getuserReq = () => {
  return http.get(`${baseUrl}user`); // {  }
};
export const notifyReq = (data) => {
  return http.post(`${baseUrl}notify`, data); // { user, title, message, image }
};
export const rmuserReq = (data) => {
  return http.delete(`${baseUrl}user`, { data }); // { is }
};

// seller
export const addSellerReq = (data) => {
  return http.post(`${baseUrl}seller`, data); // { name, phone, company, admin, password }
};
export const updSellerReq = (data) => {
  return http.put(`${baseUrl}seller`, data); // { id, name, phone, company, admin }
};
export const chSelPassReq = (data) => {
  return http.put(`${baseUrl}selpass`, data); // { id, password }
};
export const toggleSellerReq = (data) => {
  return http.put(`${baseUrl}seltog`, data); // { id }
};
export const togglePriorityReq = (data) => {
  return http.put(`${baseUrl}togglePriority`, data); // { id }
};
export const getSellersReq = (data) => {
  return http.get(`${baseUrl}seller`, { params: data }); // { admin }
};
export const getSellerPaymentsReq = (data) => {
  return http.get(`${baseUrl}sellerpays`, { params: data }); // { seller }
}; // { payments, seller }
export const rmSellerReq = (data) => {
  return http.delete(`${baseUrl}seller`, { data }); // { id }
};
export const incCutReq = (data) => {
  return http.put(`${baseUrl}incC`, data); // {  }
};
export const decCutReq = (data) => {
  return http.put(`${baseUrl}decC`, data); // {  }
};

// deliverer
export const adddelivererReq = (data) => {
  return http.post(`${baseUrl}deliverer`, data); // { name, phone, password, admin }
};
export const upddelivererReq = (data) => {
  return http.put(`${baseUrl}deliverer`, data); // { id, name, phone, admin }
};
export const chDlvPassReq = (data) => {
  return http.put(`${baseUrl}dlvpass`, data); // { id, password }
};
export const getdelivererReq = (data) => {
  return http.get(`${baseUrl}deliverer`, { params: data }); // { seller }
};
export const rmdelivererReq = (data) => {
  return http.delete(`${baseUrl}deliverer`, { data }); // { is }
};
export const ringToggleReq = (data) => {
  return http.put(`${baseUrl}ringToggle`, data); // { deliverer }
};

// products - old
export const addproductReq = (data) => {
  return http.post(`${baseUrl}supply`, data); // fd#{ name, img, image, desc, quantity }
};
export const updproductReq = (data) => {
  return http.put(`${baseUrl}supply`, data); // fd#{ id, name, image, img, desc, quantity }
};
export const getproductReq = () => {
  return http.get(`${baseUrl}supply`); // {  }
};
export const rmproductReq = (data) => {
  return http.delete(`${baseUrl}supply`, { data }); // { id }
};

// products - category-bases
export const addCategoryProdReq = (data) => {
  return http.post(`${baseUrl}categoryprod`, data); // fd#{ name, img, image, desc, category, quantity }
};
export const updateCategoryProdReq = (data) => {
  return http.put(`${baseUrl}categoryprod`, data); // fd#{ name, img, image, desc, category, quantity }
};
export const getCategoryProdsReq = (data) => {
  return http.get(`${baseUrl}categoryprod`, { params: data }); // { category }
};
export const rmCategoryProdReq = (data) => {
  return http.delete(`${baseUrl}categoryprod`, { data }); // { id }
};

// deliverer types
export const addDelivTypeReq = (data) => {
  return http.post(`${baseUrl}dt`, data); // fd#{ name, img, image }
};
export const updDelivTypeReq = (data) => {
  return http.put(`${baseUrl}dt`, data); // fd#{ id, name, image, img }
};
export const getDelivTypesReq = () => {
  return http.get(`${baseUrl}dt`); // {  }
};
export const rmDelivTypeReq = (data) => {
  return http.delete(`${baseUrl}dt`, { data }); // { id }
};

//Master Categories
export const addMasterCategoryReq = (data) => {
  return http.post(`${baseUrl}master-category`, data); // { name }
};
export const updMasterCategoryReq = (data) => {
  return http.put(`${baseUrl}master-category`, data); // { id, name }
};
export const getMasterCategoryReq = () => {
  return http.get(`${baseUrl}master-category`); // {  }
};
export const rmMasterCategoryReq = (data) => {
  return http.delete(`${baseUrl}master-category`, { data }); // { id }
};

export const updMasterCategoryBGReq = (data) => {
  return http.put(`${baseUrl}master-category/categorybg`, data); // fd#{ id, img }
};
export const rmMasterCategoryBGReq = (data) => {
  return http.delete(`${baseUrl}master-category/categorybg`, { data }); // { id }
};
export const updMasterCategoryClrReq = (data) => {
  return http.put(`${baseUrl}master-category/categoryclr`, data); // { id, color }
};
export const rmMasterCategoryClrReq = (data) => {
  return http.delete(`${baseUrl}master-category/categoryclr`, { data }); // { id }
};

// Get Master Categories
export const mastersSubcategoryReq = (data) => {
  return http.get(`${baseUrl}master-category/subcategories`, { params: data }); // { category }
};
export const addInMastersSubcategoryReq = (data) => {
  return http.post(`${baseUrl}master-category/add-sub`, data); // { category, product }
};
export const removeFromMasterCategoryReq = (data) => {
  return http.delete(`${baseUrl}master-category/del-sub`, { data }); // { category, product }
};

// categories
export const addcategoryReq = (data) => {
  return http.post(`${baseUrl}category`, data); // { name }
};
export const updcategoryReq = (data) => {
  return http.put(`${baseUrl}category`, data); // { id, name }
};
export const getcategoryReq = () => {
  return http.get(`${baseUrl}category`); // {  }
};
export const rmcategoryReq = (data) => {
  return http.delete(`${baseUrl}category`, { data }); // { id }
};
export const updcategoryBGReq = (data) => {
  return http.put(`${baseUrl}categorybg`, data); // fd#{ id, img }
};
export const rmcategoryBGReq = (data) => {
  return http.delete(`${baseUrl}categorybg`, { data }); // { id }
};
export const updcategoryClrReq = (data) => {
  return http.put(`${baseUrl}categoryclr`, data); // { id, color }
};
export const rmcategoryClrReq = (data) => {
  return http.delete(`${baseUrl}categoryclr`, { data }); // { id }
};

// catprod
export const incatReq = (data) => {
  return http.post(`${baseUrl}catprod`, data); // { category, product }
};
export const catprodsReq = (data) => {
  return http.get(`${baseUrl}catprod`, { params: data }); // { category }
};
export const outcatReq = (data) => {
  return http.delete(`${baseUrl}catprod`, { data }); // { category, product }
};

// orders
export const getOrdersReq = () => {
  return http.get(`${baseUrl}orders`); // {  }
};
export const getOrderReq = () => {
  return http.get(`${baseUrl}order`); // { order }
};
export const getDoneOrdersReq = () => {
  return http.get(`${baseUrl}doneorders`); // {  }
};
export const getDatedDoneOrdersReq = (data) => {
  return http.get(`${baseUrl}dateddoneorders`, { params: data }); // { ts }
};

// payments
export const getPaymentsReq = (data) => {
  return http.get(`${baseUrl}payments`, { params: data }); // { ts }
};

// globals
export const updGlobalsReq = (data) => {
  return http.put(`${baseUrl}globals`, data); // { cutoff, user_title, user_subtitle, auto_dec }
};
export const getGlobalsReq = () => {
  return http.get(`${baseUrl}globals`);
}; // { cutoff, min_order }

export const getSettings = () => {
  return http.get(`${baseUrl}settings`);
};

export const updateSetting = (data) => {
  return http.put(`${baseUrl}settings`, data);
};
// seller_binding
export const addBindingReq = (data) => {
  return http.post(`${baseUrl}bindings`, data); // { primary_seller, secondary_seller }
};
export const getBindingsReq = () => {
  return http.get(`${baseUrl}bindings`);
};
export const allSellersReq = () => {
  return http.get(`${baseUrl}allSellers`);
};
export const rmBindingReq = (data) => {
  return http.delete(`${baseUrl}bindings`, { data }); // { primary_seller, secondary_seller }
};
export const getNearbySellersReq = (data) => {
  return http.get(`${baseUrl}nrbSellers`, { params: data }); // { seller }
};

// banners
export const addBannerReq = (data) => {
  return http.post(`${baseUrl}banners`, data); // fd#{ bnr, section, sequence }
};
export const updBannerReq = (data) => {
  return http.put(`${baseUrl}banners`, data); // fd#{ id, bnr, section, sequence }
};
export const getBannersReq = () => {
  return http.get(`${baseUrl}banners`); // {  }
};
export const rmBannerReq = (data) => {
  return http.delete(`${baseUrl}banners`, { data }); // { id }
};

// ordercount
export const updResetTimeReq = (data) => {
  return http.put(`${baseUrl}resettime`, data); // { seller, timestamp }
};
export const getOrderCountReq = () => {
  return http.get(`${baseUrl}ordercount`); // w{  }
};

// Unit Group
export const getUnitGroupReq = () => {
  return http.get(`${baseUrl}master/unit-groups`);
};